import {
  Grid,
  Typography,
  Divider,
  Box,
  Paper,
  Button,
  Chip,
  TablePagination,
  ToggleButtonGroup,
  ToggleButton,
  Alert,
} from "@mui/material";
import { useIntl } from "react-intl";
import { Spinner } from "react-bootstrap";
import { useMemo, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ModalComponent from "components/Modal";
import { useSelector } from "react-redux";
import { StoreType } from "types/genericTypes";
import env from "react-dotenv";
import {
  IconDownload,
  IconReportSearch,
  IconShoppingCartCopy,
  IconCopyPlusFilled,
  IconCoffee,
  IconThumbDown,
  IconCancel,
  IconCheckupList,
} from "@tabler/icons-react";
import ModalConfirm from "components/ModalConfirm/ModalConfirm";
import { IconBrandAuth0 } from '@tabler/icons-react';

interface Detalles {
  id: number;
  id_movimiento: number;
  id_requisicion: number;
  id_inventario: number;
  cantidad: number;
  precio_unitario: number;
  precio_total: number;
  comentarios: string;
  created_at: Date;
  inventario: Inventario | null;
}

interface Inventario {
  id: number;
  nombre: string;
  clave: string;
  cantidad: number;
  maximos: number;
  minimos: number;
  id_unidad_medida: number;
  id_categoria: number;
  id_ubicacion: number;
  id_tipo_producto: number;
  unidad_medida: UnidadMedida | null;
  categoria: Categoria | null;
  ubicacion: Ubicacion | null;
  tipo_producto: TipoProducto | null;
}

interface UnidadMedida {
  id: number;
  nombre: string;
}

interface Categoria {
  id: number;
  nombre: string;
}

interface Empresa {
  id: number;
  clave: string;
  razon_social: string;
  nombre: string;
  logo_empresa: string;
}

interface Ubicacion {
  id: number;
  nombre: string;
  id_almacen: number;
  almacen: Almacen | null;
}

interface Almacen {
  id: number;
  nombre: string;
}

interface TipoProducto {
  id: number;
  nombre: string;
}

interface Requisicion {
  id: number;
  folio: string;
  id_creador: number;
  id_usuario_solicitante: number;
  nombre_creador: string;
  nombre_usuario: string;
  nombre_empresa: string;
  orden_compra: OrdenCompra;
  computo: string;
  computo_tipo: string;
  estatus_requisicion: number;
  id_proyecto: number;
  nombre_proyecto: string;
  extras: string;
  imagen_referencia: string;
  created_at: Date;
  empresa: Empresa;
  detalles: Detalles[];
}

interface OrdenCompraDetalle {
  id: number;
  id_orden: number;
  id_inventario: number;
  cantidad: number;
  precio: number;
  precio_total: number;
  estatus?: number;
}

interface OrdenCompra {
  id: number;
  numero: string;
  estatus_id: number;
  estatus: string;
  detalles_orden_compra?: OrdenCompraDetalle[];
}
interface NivelJefeInmediato {
  id_usuario: number;
  jefe_inmediato: number;
  nivel: string;
}

interface DetalleInventarioProps {
  verRequisicion?: Requisicion | null;
  detallesRequisicionPaginados: Detalles[];
  page: number;
  rowsPerPage: number;
  procesando?: boolean;
  procesandoMandarAutorizar?: boolean;
  handleChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  usuarioArjion?: string | null;
  procesoAutorizacion: (datos: any) => Promise<void>;
  idUsuario?: number;
  isAlertOpenAutorizar: boolean;
  handleisAlertOpenAutorizar: () => void;
  handleisAlertCloseAutorizar: () => void;
  accionRequisicion: string;
  setAccionRequisicion: React.Dispatch<React.SetStateAction<string>>;
  handleAccionRequisicion: (
    event: React.MouseEvent<HTMLElement>,
    nuevaAccionRequisicion: string
  ) => void;
  jefeInmediato: NivelJefeInmediato[];
  nombreCompletoAutorizando?: string;
  setVerCotizacion: React.Dispatch<React.SetStateAction<any>>;
  handleisAlertOpenCotizacion: () => void;
  getJefeInmediato: (datos: any) => Promise<void>;
  surtirDisponible: (datos: any) => Promise<void>;
  marcarAtendida: (datos: any) => Promise<void>;
  cancelarRequisicion: (datos: any) => Promise<void>;
  procesandoSurtir?: boolean;
  handleisAlertCrearInventarioOpen: () => void;
  setIdDetalleRequisicion: React.Dispatch<React.SetStateAction<number>>;
  enviarAutorizar: (datos: any) => Promise<void>;
}

const RequisicionPorId = ({
  verRequisicion,
  detallesRequisicionPaginados,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  procesando,
  procesandoMandarAutorizar,
  usuarioArjion,
  procesoAutorizacion,
  idUsuario,
  isAlertOpenAutorizar,
  handleisAlertOpenAutorizar,
  handleisAlertCloseAutorizar,
  accionRequisicion,
  setAccionRequisicion,
  handleAccionRequisicion,
  jefeInmediato,
  nombreCompletoAutorizando,
  setVerCotizacion,
  handleisAlertOpenCotizacion,
  getJefeInmediato,
  surtirDisponible,
  marcarAtendida,
  procesandoSurtir,
  cancelarRequisicion,
  handleisAlertCrearInventarioOpen,
  setIdDetalleRequisicion,
  enviarAutorizar
}: DetalleInventarioProps) => {
  if (!verRequisicion) return null;
  const intl = useIntl();

  const [isModalImagenOpen, setIsModalImagenOpen] = useState(false);
  const handleOpenModalImagen = () => setIsModalImagenOpen(true);
  const handleCloseModalImagen = () => setIsModalImagenOpen(false);

  const [openConfirmEnviarDG, setOpenConfirmEnviarDG] = useState(false);

  const idAreaDireccionUsuario = useSelector(
    (state: StoreType) => state?.app?.user?.data?.id_area || 0
  );

  const handleConfirmar = (comentarios?: string) => {
    const datos = {
      id_requisicion: verRequisicion?.id,
      id_usuario_autorizando: idUsuario,
      total_requisicion: totalPedido,
      tipo_accion: accionRequisicion,
      que_es: tipoUsuarioArjion,
      ...verRequisicion,
    };
    //console.log(datos);
    accionRequisicion === "cancelar" ? cancelarRequisicion(datos) : procesoAutorizacion(datos);
    setOpenConfirmEnviarDG(false);
  };

  const privilegiosToRol: Record<string, string> = {
    "froebel.ivan": "admin",
    "torres.tannya": "daf",
    "salazar.mario": "dg",
    "hernandez.lucero": "compras",
    "delarosa.brenda": "compras",
  };

  const tipoUsuarioArjion = privilegiosToRol[usuarioArjion as string] ?? "";

  const getEstadoColor = (
    estatus_requisicion: number
  ): "info" | "warning" | "primary" | "default" | "error" | "success" => {
    switch (estatus_requisicion) {
      case 1:
        return "info"; // Creada
      case 2:
        return "warning"; // Autorizada Jefe Inmediato
      case 3:
        return "primary"; // Autorizada Director
      case 4:
        return "primary"; // Autorizada DAF
      case 5:
        return "primary"; // Autorizada DG
      case 6:
        return "success"; // Atendida
      case 7:
        return "error"; // Rechazada
      case 8:
        return "warning"; // Pendiente DAF
      case 9:
        return "error"; // Cancelada
      case 10:
        return "warning"; // Pendiente DG
      default:
        return "default";
    }
  };

  const estadosMap: { [key: number]: string } = {
    1: "Creada",
    2: "Autorizada Jefe Inmediato",
    3: "Autorizada Director de Area",
    4: "Autorizada DAF",
    5: "Autorizada DG",
    6: "Atendida",
    7: "Rechazada",
    8: "Pendiente DAF",
    9: "Cancelada",
    10: "Pendiente DG",
  };

  const traducirEstado = (estado: number | null): string => {
    if (estado === null || estado === undefined) return "SIN ESTADO";
    return estadosMap[estado] ?? "SIN ESTADO";
  };

  const detallesOrdenCompraMap = useMemo(() => {
    const detalles = verRequisicion?.orden_compra?.detalles_orden_compra ?? [];
    const map = new Map<number, OrdenCompraDetalle>();
    detalles.forEach((d) => map.set(d.id_inventario, d));
    return map;
  }, [verRequisicion?.orden_compra?.detalles_orden_compra]);

  const tieneOrdenCompraConDetalles =
    !!verRequisicion.orden_compra?.id &&
    (verRequisicion.orden_compra?.detalles_orden_compra?.length ?? 0) > 0;

  const totalPedido = useMemo(() => {
    const detalles = verRequisicion?.detalles ?? [];
    return detalles.reduce((sum, d) => {
      const detalleOC = tieneOrdenCompraConDetalles
        ? detallesOrdenCompraMap.get(d.id_inventario)
        : undefined;
      const total = detalleOC ? detalleOC.precio_total : d.precio_total;
      return sum + Number(total);
    }, 0);
  }, [verRequisicion?.detalles, tieneOrdenCompraConDetalles, detallesOrdenCompraMap]);

  const colorMap: Record<string, { background: string; color: string }> = {
    autorizar: { background: "#4caf50", color: "#fff" },
    rechazar: { background: "#f44336", color: "#fff" },
    "enviar a dg": { background: "#ff9800", color: "#fff" },
  };

  const defaultStyle = { background: "#31a3dc", color: "#fff" };

  const actionStyle = accionRequisicion
    ? colorMap[accionRequisicion] ?? defaultStyle
    : defaultStyle;

  const CLAVES_SIN_ALERTA_INVENTARIO = ["PN-C-NI", "PN-A-NI"];

  const productosConAlerta = useMemo(() => {
    const detalles = verRequisicion?.detalles ?? [];
    return detalles.map((producto) => {
      const esSinAlerta = CLAVES_SIN_ALERTA_INVENTARIO.includes(producto.inventario?.clave ?? "");

      const cantidadDisponible = producto.inventario?.cantidad ?? 0;
      const cantidadPedida = producto.cantidad ?? 0;
      const minimos = producto.inventario?.minimos ?? 0;

      const cantidadRestante = Math.max(0, cantidadDisponible - cantidadPedida);
      const cantidadFaltante = Math.max(0, cantidadPedida - cantidadDisponible);
      const quedaBajoMinimo = !esSinAlerta && cantidadDisponible > 0 && cantidadRestante <= minimos;
      const yaEnMinimos = !esSinAlerta && cantidadDisponible <= minimos;

      return {
        ...producto,
        cantidadRestante,
        quedaBajoMinimo,
        yaEnMinimos,
        cantidadFaltante,
        esSinAlerta,
      };
    });
  }, [verRequisicion?.detalles]);

  const hayProductosYaEnMinimos = useMemo(() => {
    return productosConAlerta.some((d) => d.yaEnMinimos);
  }, [productosConAlerta]);

  const hayProductosBajoMinimo = useMemo(() => {
    return productosConAlerta.some((d) => d.quedaBajoMinimo);
  }, [productosConAlerta]);

  const productosConAlertaPaginados = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return productosConAlerta.slice(startIndex, endIndex);
  }, [productosConAlerta, page, rowsPerPage]);

  const productosSinInventario = useMemo(() => {
    return productosConAlerta.filter(
      (p) => !p.esSinAlerta && p.inventario?.cantidad === 0 && p?.cantidad !== 0
    );
  }, [productosConAlerta]);

  const productosSurtidosCompletamente = useMemo(() => {
    return productosConAlerta.filter((p) => !p.esSinAlerta && p?.cantidad === 0);
  }, [productosConAlerta]);

  const hayProductosSinInventario = useMemo(() => {
    return productosSinInventario.length > 0;
  }, [productosSinInventario]);

  const hayProductosSurtidosCompletamente = useMemo(() => {
    return productosSurtidosCompletamente.length > 0;
  }, [productosSinInventario]);

  const productosParaSurtir = useMemo(() => {
    return productosConAlerta.filter((p) => (p.inventario?.cantidad ?? 0) > 0 && p?.cantidad !== 0);
  }, [productosConAlerta]);

  const todosSurtidosCompletamente = useMemo(() => {
    const detalles = verRequisicion?.detalles ?? [];
    return detalles.length > 0 && detalles.every((d) => d.cantidad === 0);
  }, [verRequisicion?.detalles]);

  const alertCenteredSx = {
    m: 2,
    justifyContent: "center",
    textAlign: "center",
  };

  const urlImagenReferencia = verRequisicion.imagen_referencia
    ? `${env.API_URL_ASSETS}referencias_requisicion/${verRequisicion.imagen_referencia}`
    : null;

  const urlLogoEmpresa = verRequisicion.empresa.logo_empresa
    ? `${env.API_URL_ASSETS}logo_empresas/${verRequisicion.empresa.logo_empresa}`
    : null;

  const esJefeInmediatoDeAlgunNivel = useMemo(() => {
    return jefeInmediato?.some((nivel) => nivel.id_usuario === idUsuario) ?? false;
  }, [jefeInmediato, idUsuario]);

  const esJefeInmediatoNivelA = useMemo(() => {
    return jefeInmediato?.some((nivel) => nivel.id_usuario === idUsuario && nivel.nivel === "A") ?? false;
  }, [jefeInmediato, idUsuario]);

  const puedeRechazar =
    (esJefeInmediatoNivelA && verRequisicion.estatus_requisicion === 1) ||
    (esJefeInmediatoDeAlgunNivel && verRequisicion.estatus_requisicion === 1) ||
    (esJefeInmediatoDeAlgunNivel && verRequisicion.estatus_requisicion === 2) ||
    (tipoUsuarioArjion === "dg" && verRequisicion.estatus_requisicion === 10) ||
    (tipoUsuarioArjion === "daf" && verRequisicion.estatus_requisicion === 8);
  const puedeCancelar =
    idUsuario === verRequisicion?.id_creador && verRequisicion.estatus_requisicion === 1;
  const puedeAutorizar =
    (esJefeInmediatoDeAlgunNivel && verRequisicion.estatus_requisicion === 1) ||
    (esJefeInmediatoDeAlgunNivel && verRequisicion.estatus_requisicion === 2) ||
    (tipoUsuarioArjion === "daf" && verRequisicion.estatus_requisicion === 8) ||
    (tipoUsuarioArjion === "dg" && verRequisicion.estatus_requisicion === 10);
  const puedeCotizarMandarDAF = todosSurtidosCompletamente;
  const puedeSurtirDisponible = productosParaSurtir.length === 0;
  const puedeEnviarAutorizarPrimeraVez =
    idUsuario === verRequisicion?.id_creador && verRequisicion.estatus_requisicion === 1;

  return (
    <Box sx={{ px: 2, pb: 2, mt: 3 }}>
      <Grid container spacing={2}>
        {/* Información de la requisicion */}
        <Grid item xs={12}>
          <Typography variant="h4" sx={{ textAlign: "center" }}>
            Requisición {verRequisicion?.folio}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {urlLogoEmpresa ? (
            <Box
              component="img"
              src={urlLogoEmpresa}
              alt="Logo empresa"
              sx={{
                mt: 0.5,
                width: "auto",
                height: 40,
              }}
            />
          ) : (
            <Typography variant="body2" fontWeight="medium">
              Sin logo de la empresa
            </Typography>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Estatus de la requisición
          </Typography>
          <Chip
            label={traducirEstado(verRequisicion.estatus_requisicion).toUpperCase()}
            color={getEstadoColor(verRequisicion.estatus_requisicion)}
            sx={{ fontWeight: "bold" }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={7}
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: { xs: "center", sm: "end" },
          }}
          gap={1}
        >
          {!verRequisicion.orden_compra?.id && (
            <>
              {tipoUsuarioArjion == "compras" && (
                <>
                  <Button
                    sx={{
                      color: "#fff",
                      background: "#247839",
                      fontSize: "0.75rem",
                      padding: "6px 8px",
                      "&:hover": {
                        background: "#134a21",
                      },
                      "&:focus": {
                        background: "#134a21 !important",
                      },
                    }}
                    variant="contained"
                    disabled={
                      puedeSurtirDisponible || [1, 2].includes(verRequisicion.estatus_requisicion)
                    }
                    startIcon={<IconShoppingCartCopy stroke={2} />}
                    onClick={(e: any) => {
                      const datos = {
                        id_requisicion: verRequisicion?.id,
                        id_usuario_surtiendo: idUsuario,
                        id_creador: verRequisicion?.id_creador,
                        id_usuario_solicitante: verRequisicion?.id_usuario_solicitante,
                        total_requisicion: totalPedido,
                        detalles: productosParaSurtir,
                        ids_inventario: verRequisicion.detalles.map((d) => d.id_inventario),
                      };
                      surtirDisponible(datos);
                    }}
                  >
                    {procesandoSurtir ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Surtiendo...{" "}
                      </>
                    ) : (
                      intl.formatMessage({ id: "general_surtir_disponible" })
                    )}
                  </Button>
                  {/* CAPACIDAD DE COTIZAR O MANDAR A DAF*/}
                  <Button
                    sx={{
                      color: "#000",
                      background: "#dec162",
                      fontSize: "0.75rem",
                      padding: "6px 8px",
                      "&:hover": {
                        background: "#826f30",
                      },
                      "&:focus": {
                        background: "#826f30 !important",
                      },
                    }}
                    variant="contained"
                    disabled={
                      puedeCotizarMandarDAF ||
                      [1, 2, 4, 6, 7, 8, 9].includes(verRequisicion.estatus_requisicion)
                    }
                    startIcon={<IconReportSearch stroke={2} />}
                    onClick={(e: any) => {
                      const nuevaAccion =
                        totalPedido >= 50000 && verRequisicion.estatus_requisicion === 3
                          ? "mandar a daf"
                          : "cotizar";
                      setAccionRequisicion(nuevaAccion);
                      const datos = {
                        id_requisicion: verRequisicion?.id,
                        id_usuario_autorizando: idUsuario,
                        total_requisicion: totalPedido,
                        tipo_accion: nuevaAccion,
                        que_es: tipoUsuarioArjion,
                        ...verRequisicion,
                        ids_inventario: verRequisicion.detalles
                          .filter((p) => p.cantidad !== 0)
                          .map((d) => d.id_inventario),
                      };
                      if (totalPedido >= 50000 && verRequisicion.estatus_requisicion === 3) {
                        setAccionRequisicion("mandar a daf");
                        setOpenConfirmEnviarDG(true);
                      } else {
                        setVerCotizacion(datos);
                        handleisAlertOpenCotizacion();
                      }
                    }}
                  >
                    {procesandoMandarAutorizar ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Cargando...{" "}
                      </>
                    ) : totalPedido >= 50000 && verRequisicion.estatus_requisicion === 3 ? (
                      intl.formatMessage({ id: "general_mandar_daf" })
                    ) : (
                      intl.formatMessage({ id: "general_cotizar" })
                    )}
                  </Button>
                </>
              )}

              {tipoUsuarioArjion === "compras" && todosSurtidosCompletamente && (
                <Button
                  sx={{
                    color: "#fff",
                    background: "#c7348f",
                    fontSize: "0.75rem",
                    padding: "6px 8px",
                  }}
                  variant="contained"
                  endIcon={<AddIcon />}
                  disabled={verRequisicion.estatus_requisicion === 6}
                  onClick={(e: any) => {
                    const datos = {
                      id_requisicion: verRequisicion?.id,
                      id_usuario: idUsuario,
                    };

                    marcarAtendida(datos);
                  }}
                >
                  {procesando ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Cargando...{" "}
                    </>
                  ) : (
                    intl.formatMessage({ id: "general_marcar_atendida" })
                  )}
                </Button>
              )}

              {/* BOTONES DE ACCIONES POR SEPARADO */}
              {/* ENVIAR A DG POR DAF SI TIENE ESTATUS PENDIENTE DAF */}
              {tipoUsuarioArjion === "daf" && verRequisicion.estatus_requisicion === 8 && (
                <Button
                  sx={{
                    background: "#ff9800",
                    color: "#fff",
                    fontSize: "0.75rem",
                    padding: "6px 8px",
                    "&:hover": {
                      background: "#a66302",
                    },
                    "&:focus": {
                      background: "#a66302 !important",
                    },
                  }}
                  variant="contained"
                  startIcon={<IconCoffee stroke={2} />}
                  disabled={verRequisicion.estatus_requisicion !== 8}
                  onClick={(e: any) => {
                    setAccionRequisicion("enviar a dg");
                    setOpenConfirmEnviarDG(true);
                  }}
                >
                  {procesandoMandarAutorizar ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Cargando...{" "}
                    </>
                  ) : (
                    intl.formatMessage({ id: "enviar_a_dg" })
                  )}
                </Button>
              )}
              {/* MANDAR A AUTORIZAR POR PRIMERA VEZ SOLO POR EL CREADOR */}
              <Button
                sx={{
                  ...actionStyle,
                  fontSize: "0.75rem",
                  padding: "6px 8px",
                }}
                variant="contained"
                startIcon={<IconBrandAuth0 stroke={2} />}
                disabled={!puedeEnviarAutorizarPrimeraVez}
                onClick={(e: any) => {
                  const datos = {
                    id_requisicion: verRequisicion?.id,
                    id_usuario: idUsuario,
                    ...verRequisicion,
                  };
                  enviarAutorizar(datos);
                }}
              >
                {procesandoMandarAutorizar ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Enviando...{" "}
                  </>
                ) : (
                  intl.formatMessage({ id: "general_enviar_autorizar" })
                )}
              </Button>
              {/* CAPACIDAD DE AUTORIZAR*/}
              <Button
                sx={{
                  color: "#fff",
                  background: "#3ec972",
                  fontSize: "0.75rem",
                  padding: "6px 8px",
                  "&:hover": {
                    background: "#269951",
                  },
                  "&:focus": {
                    background: "#269951 !important",
                  },
                }}
                variant="contained"
                startIcon={<IconCheckupList stroke={2} />}
                disabled={
                  !puedeAutorizar || [5, 6, 7, 9].includes(verRequisicion.estatus_requisicion)
                }
                onClick={(e: any) => {
                  setAccionRequisicion("autorizar");
                  setOpenConfirmEnviarDG(true);
                }}
              >
                {intl.formatMessage({ id: "general_autorizar" })}
              </Button>
              {/* CAPACIDAD DE RECHAZAR LA REQUISICIÓN POR EL JEFE INMEDIATO*/}
              {esJefeInmediatoDeAlgunNivel ||
                ![6, 7, 9].includes(verRequisicion.estatus_requisicion) ? (
                <Button
                  sx={{
                    background: "#ab1829",
                    color: "#fff",
                    fontSize: "0.75rem",
                    padding: "6px 8px",
                    "&:hover": {
                      background: "#6b0d18",
                    },
                    "&:focus": {
                      background: "#6b0d18 !important",
                    },
                  }}
                  variant="contained"
                  startIcon={<IconThumbDown stroke={2} />}
                  disabled={!puedeRechazar}
                  onClick={(e: any) => {
                    setAccionRequisicion("rechazar");
                    setOpenConfirmEnviarDG(true);
                  }}
                >
                  {procesandoMandarAutorizar ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Cargando...{" "}
                    </>
                  ) : (
                    intl.formatMessage({ id: "general_rechazar" })
                  )}
                </Button>
              ) : null}
              {idUsuario === verRequisicion?.id_creador ? (
                <Button
                  sx={{
                    background: "#ab1829",
                    color: "#fff",
                    fontSize: "0.75rem",
                    padding: "6px 8px",
                    "&:hover": {
                      background: "#6b0d18",
                    },
                    "&:focus": {
                      background: "#6b0d18 !important",
                    },
                  }}
                  variant="contained"
                  startIcon={<IconCancel stroke={2} />}
                  disabled={!puedeCancelar}
                  onClick={(e: any) => {
                    setAccionRequisicion("cancelar");
                    setOpenConfirmEnviarDG(true);
                  }}
                >
                  {procesandoMandarAutorizar ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Cargando...{" "}
                    </>
                  ) : (
                    intl.formatMessage({ id: "general_cancelar" })
                  )}
                </Button>
              ) : null}
            </>
          )}
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Grid container>
              {tipoUsuarioArjion === "compras" && !todosSurtidosCompletamente && (
                <Alert severity="info" sx={alertCenteredSx}>
                  Al surtir los productos disponibles, se restará lo solicitado de la cantidad
                  disponible en inventario y el resto se deberá cotizar
                </Alert>
              )}
              {tipoUsuarioArjion === "compras" && todosSurtidosCompletamente && (
                <Alert severity="success" sx={alertCenteredSx}>
                  Todos los productos han sido surtidos completamente
                </Alert>
              )}
            </Grid>
            <Divider sx={{ m: 2 }} />
            {/* Info general */}
            <Grid item xs={12}>
              <Paper elevation={2} sx={{ p: 2 }}>
                <Typography
                  variant="h6"
                  color="primary"
                  gutterBottom
                  sx={{ color: "#004c93", textAlign: "center" }}
                >
                  Información general
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Creado por
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {verRequisicion.nombre_creador}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Solicitante
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {verRequisicion.nombre_usuario}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Autorizando
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {nombreCompletoAutorizando}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Proyecto
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {verRequisicion.nombre_proyecto}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Empresa
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {verRequisicion.nombre_empresa}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="body2" color="text.secondary">
                      Fecha
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {new Date(verRequisicion.created_at).toLocaleDateString("es-MX")}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            <Divider sx={{ m: 2 }} />
            {/* Info referencias */}
            <Grid item xs={12}>
              <Paper elevation={2} sx={{ p: 2 }}>
                <Typography
                  variant="h6"
                  color="primary"
                  gutterBottom
                  sx={{ color: "#004c93", textAlign: "center" }}
                >
                  Referencias
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" color="text.secondary">
                      Link/comentarios
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {verRequisicion.extras}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" color="text.secondary">
                      Imagen referencia
                    </Typography>
                    {urlImagenReferencia ? (
                      <Box
                        component="img"
                        src={urlImagenReferencia}
                        alt="Imagen de referencia"
                        onClick={handleOpenModalImagen}
                        sx={{
                          mt: 0.5,
                          width: 100,
                          height: 100,
                          objectFit: "cover",
                          borderRadius: 1,
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          "&:hover": { opacity: 0.85 },
                        }}
                      />
                    ) : (
                      <Typography variant="body2" fontWeight="medium">
                        Sin imagen de referencia
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            <Divider sx={{ mb: 2 }} />
            {/* Detalles / productos */}
            <Grid item xs={12}>
              <Typography
                variant="h6"
                color="primary"
                gutterBottom
                sx={{ color: "#004c93", textAlign: "center" }}
              >
                Productos solicitados ({verRequisicion.detalles?.length ?? 0})
              </Typography>
              <Divider sx={{ mb: 2 }} />
              {tipoUsuarioArjion === "compras" && hayProductosYaEnMinimos && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  Algunos productos ya se encuentran en su nivel mínimo (o por debajo) de inventario
                </Alert>
              )}
              {tipoUsuarioArjion === "compras" && hayProductosSinInventario && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {productosSinInventario.length === 1 ? (
                    `El producto "${productosSinInventario[0].inventario?.nombre}" no tiene inventario disponible y no se incluirá al surtir (será necesario cotizarlo)`
                  ) : (
                    <>
                      Los siguientes productos no tienen inventario disponible y no se incluirán al
                      surtir (será necesario cotizarlos):
                      <Box component="ul" sx={{ m: 0, pl: 3 }}>
                        {productosSinInventario.map((p) => (
                          <li key={p.id}>{p.inventario?.nombre}</li>
                        ))}
                      </Box>
                    </>
                  )}
                </Alert>
              )}
              {tipoUsuarioArjion === "compras" && hayProductosSurtidosCompletamente && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  {productosSurtidosCompletamente.length === 1 ? (
                    `El producto "${productosSurtidosCompletamente[0].inventario?.nombre}" se ha surtido completamente y no se incluirá al cotizar`
                  ) : (
                    <>
                      Los siguientes se surtieron completamente y no se incluirán al cotizar:
                      <Box component="ul" sx={{ m: 0, pl: 3 }}>
                        {productosSurtidosCompletamente.map((p) => (
                          <li key={p.id}>{p.inventario?.nombre}</li>
                        ))}
                      </Box>
                    </>
                  )}
                </Alert>
              )}
              {tipoUsuarioArjion === "compras" && hayProductosBajoMinimo && (
                <Alert severity="warning" sx={{ mb: 2 }}>
                  Algunos productos quedarían por debajo del minimo después de surtirlos
                </Alert>
              )}
              {productosConAlertaPaginados.map((detalle, index: number) => {
                const detalleOC = tieneOrdenCompraConDetalles
                  ? detallesOrdenCompraMap.get(detalle.id_inventario)
                  : undefined;

                const precioUnitarioMostrar = detalleOC
                  ? detalleOC.precio
                  : detalle.precio_unitario;
                const precioTotalMostrar = detalleOC
                  ? detalleOC.precio_total
                  : detalle.precio_total;
                return (
                  <Box
                    key={detalle.id}
                    sx={{
                      mb: 2,
                      p: 1,
                      position:
                        detalle.esSinAlerta && tipoUsuarioArjion === "compras" ? "relative" : null,
                      border:
                        detalle.esSinAlerta && tipoUsuarioArjion === "compras"
                          ? "1px solid #8da4f0"
                          : tipoUsuarioArjion === "compras" && detalle?.cantidad === 0
                            ? "1px solid #4caf50"
                            : tipoUsuarioArjion === "compras" &&
                              (detalle.inventario?.cantidad ?? 0) === 0
                              ? "1px solid #f44336"
                              : tipoUsuarioArjion === "compras" && detalle.yaEnMinimos
                                ? "1px solid #d32f2f"
                                : detalle.quedaBajoMinimo && tipoUsuarioArjion === "compras"
                                  ? "1px solid #ff9800"
                                  : "1px solid #e0e0e0",
                      borderRadius: 1,
                      backgroundColor:
                        detalle.esSinAlerta && tipoUsuarioArjion === "compras"
                          ? "transparent"
                          : tipoUsuarioArjion === "compras" && detalle?.cantidad === 0
                            ? "#e8f5e9"
                            : tipoUsuarioArjion === "compras" &&
                              (detalle.inventario?.cantidad ?? 0) === 0
                              ? "#ffebee"
                              : tipoUsuarioArjion === "compras" && detalle.yaEnMinimos
                                ? "#fdecea"
                                : detalle.quedaBajoMinimo && tipoUsuarioArjion === "compras"
                                  ? "#fff3e0"
                                  : "transparent",
                    }}
                  >
                    {detalle.esSinAlerta && tipoUsuarioArjion === "compras" && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          display: "flex",
                          alignItems: "center",
                          color: "#31a3dc",
                          border: "1px solid #8da4f0",
                          p: 0.5,
                          "&:hover": {
                            background: "#31a3dc",
                            color: "#fff",
                            cursor: "pointer",
                          },
                        }}
                        onClick={(e: any) => {
                          setIdDetalleRequisicion(detalle.id);
                          handleisAlertCrearInventarioOpen();
                        }}
                      >
                        <IconCopyPlusFilled size={30} />
                      </Box>
                    )}
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={tipoUsuarioArjion === "compras" ? 3 : 5}>
                        <Typography variant="body2" color="text.secondary">
                          Producto
                        </Typography>
                        <Typography variant="body2" fontWeight="medium">
                          {detalle.inventario?.nombre}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {detalle.inventario?.clave}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={1}>
                        <Typography variant="body2" color="text.secondary">
                          Solicitado
                        </Typography>
                        <Typography variant="body2" fontWeight="medium">
                          {detalle.cantidad}
                        </Typography>
                      </Grid>
                      {tipoUsuarioArjion === "compras" && (
                        <Grid item xs={6} md={2}>
                          <Typography variant="body2" color="text.secondary">
                            En inventario
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="medium"
                            color={detalle.quedaBajoMinimo ? "error" : "inherit"}
                          >
                            {detalle?.inventario?.cantidad}
                            {detalle.yaEnMinimos && " 🔴"}
                            {detalle.quedaBajoMinimo && " ⚠️"}
                          </Typography>
                        </Grid>
                      )}
                      {tipoUsuarioArjion === "compras" && (
                        <Grid item xs={6} md={1}>
                          <Typography variant="body2" color="text.secondary">
                            Máximos
                          </Typography>
                          <Typography variant="body2" fontWeight="medium">
                            {detalle?.inventario?.maximos}
                          </Typography>
                        </Grid>
                      )}
                      {tipoUsuarioArjion === "compras" && (
                        <Grid item xs={6} md={1}>
                          <Typography variant="body2" color="text.secondary">
                            Mínimos
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="medium"
                            color={detalle.quedaBajoMinimo ? "error" : "inherit"}
                          >
                            {detalle?.inventario?.minimos}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={6} md={1}>
                        <Typography variant="body2" color="text.secondary">
                          P. Unitario
                        </Typography>
                        <Typography variant="body2" fontWeight="medium">
                          $
                          {Number(detalle.precio_unitario).toLocaleString("es-MX", {
                            minimumFractionDigits: 2,
                          })}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={tipoUsuarioArjion === "compras" ? 1 : 2}>
                        <Typography variant="body2" color="text.secondary">
                          Total
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="medium"
                          color="primary"
                          sx={{ color: "#004c93" }}
                        >
                          $
                          {Number(detalle.precio_total).toLocaleString("es-MX", {
                            minimumFractionDigits: 2,
                          })}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={tipoUsuarioArjion === "compras" ? 1 : 2}>
                        <Typography variant="body2" color="text.secondary">
                          Almacén
                        </Typography>
                        <Typography variant="body2" fontWeight="medium">
                          {detalle.inventario?.ubicacion?.almacen?.nombre ?? "—"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
              {/* Total */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  mt: 1,
                  p: 1,
                  backgroundColor: "#e8f4fd",
                  borderRadius: 1,
                }}
              >
                <Typography variant="body2" fontWeight="bold" sx={{ mr: 1 }}>
                  Total de la requisición:
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="primary"
                  sx={{ color: "#004c93" }}
                >
                  ${totalPedido.toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                </Typography>
              </Box>
              {/* Paginación */}
              <TablePagination
                component="div"
                count={verRequisicion.detalles?.length ?? 0}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[3, 5, 10]}
                labelRowsPerPage="Por página:"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    justifyContent: "space-between",
                    padding: "8px 16px",
                  },
                  ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                    margin: 0,
                  },
                  ".MuiTablePagination-actions svg": { transform: "scaleX(-1)" },
                }}
              />
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <ModalConfirm
        open={openConfirmEnviarDG}
        title="Confirmar acción"
        text={
          accionRequisicion === "autorizar" ? (
            <>
              ¿Desea <strong>autorizar</strong> la requisición{" "}
              <strong>{verRequisicion?.folio}</strong>?
            </>
          ) : accionRequisicion === "enviar a dg" ? (
            <>
              ¿Desea <strong>enviar</strong> la requisición <strong>{verRequisicion?.folio}</strong>{" "}
              a Dirección General?
            </>
          ) : accionRequisicion === "mandar a daf" ? (
            <>
              ¿Desea <strong>enviar</strong> la requisición <strong>{verRequisicion?.folio}</strong>{" "}
              a Dirección de Administración y Finanzas?
            </>
          ) : accionRequisicion === "rechazar" ? (
            <>
              ¿Desea <strong>rechazar</strong> la requisición{" "}
              <strong>{verRequisicion?.folio}</strong>?
            </>
          ) : accionRequisicion === "cancelar" ? (
            <>
              ¿Desea <strong>cancelar</strong> la requisición{" "}
              <strong>{verRequisicion?.folio}</strong>?
            </>
          ) : null
        }
        onAcept={handleConfirmar}
        onCancel={() => setOpenConfirmEnviarDG(false)}
      />
      <ModalComponent
        handleClose={handleisAlertCloseAutorizar}
        isOpen={isAlertOpenAutorizar}
        key={"alerta"}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12} mt={2} mb={2}>
            <Typography
              variant="h6"
              color="primary"
              gutterBottom
              sx={{ color: "#004c93", textAlign: "center" }}
            >
              ¿QUÉ DESEA HACER?
            </Typography>
            <Typography variant="caption" color="info" gutterBottom sx={{ textAlign: "center" }}>
              Selecciona una acción para que el botón de autorizar se habilite
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <ToggleButtonGroup
              value={accionRequisicion}
              exclusive
              onChange={handleAccionRequisicion}
              aria-label="Acciones de la requisición"
              sx={{ margin: "0 10px" }}
            >
              <ToggleButton
                value="autorizar"
                aria-label="autorizar"
                sx={{
                  fontWeight: "bold",
                  "&.Mui-selected": {
                    bgcolor: "green",
                    color: "#fff",
                    "&:hover": { bgcolor: "darkgreen" },
                  },
                }}
              >
                AUTORIZAR
              </ToggleButton>

              <ToggleButton
                value="rechazar"
                aria-label="rechazar"
                sx={{
                  fontWeight: "bold",
                  "&.Mui-selected": {
                    bgcolor: "red",
                    color: "#fff",
                    "&:hover": { bgcolor: "darkred" },
                  },
                }}
              >
                RECHAZAR
              </ToggleButton>
              {tipoUsuarioArjion === "daf" && (
                <ToggleButton
                  value="enviar a dg"
                  aria-label="enviar a dg"
                  sx={{
                    fontWeight: "bold",
                    "&.Mui-selected": {
                      bgcolor: "orange",
                      color: "#fff",
                      "&:hover": { bgcolor: "darkorange" },
                    },
                  }}
                >
                  ENVIAR A DG
                </ToggleButton>
              )}
            </ToggleButtonGroup>
          </Grid>
          <Grid item xs={6}>
            <Button
              sx={{
                ...actionStyle,
                fontSize: "0.75rem",
                padding: "6px 8px",
              }}
              variant="contained"
              endIcon={<AddIcon />}
              disabled={accionRequisicion === "" || accionRequisicion === null}
              onClick={(e: any) => {
                const datos = {
                  id_requisicion: verRequisicion?.id,
                  id_usuario_autorizando: idUsuario,
                  total_requisicion: totalPedido,
                  tipo_accion: accionRequisicion,
                  que_es: tipoUsuarioArjion,
                  ...verRequisicion,
                };
                procesoAutorizacion(datos);
              }}
            >
              {procesandoMandarAutorizar ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Cargando...{" "}
                </>
              ) : (
                accionRequisicion || intl.formatMessage({ id: "general_seleccionar_accion" })
              )}
            </Button>
          </Grid>
        </Grid>
      </ModalComponent>
      {/* MODAL PARA VER IMAGEN REFERENCIA A TAMAÑO ORIGINAL */}
      <ModalComponent
        handleClose={handleCloseModalImagen}
        isOpen={isModalImagenOpen}
        key="vista-imagen-referencia"
        titleButtonAction="Descargar imagen"
        colorAction="#40ad80"
        hoverColorAction="#338a66"
        iconButtonAction={<IconDownload stroke={2} />}
        handleAction={() => {
          if (!urlImagenReferencia) return;

          const link = document.createElement("a");
          link.href = urlImagenReferencia;
          link.download = verRequisicion.imagen_referencia || "imagen_referencia";
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }}
      >
        {urlImagenReferencia && (
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ maxHeight: "80vh", overflow: "auto" }}
              >
                <Box
                  component="img"
                  src={urlImagenReferencia}
                  alt="Imagen de referencia"
                  sx={{
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    objectFit: "contain",
                    borderRadius: 1,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </ModalComponent>
    </Box>
  );
};
export default RequisicionPorId;
